export default {
  primary: {
    color: "#00203F",
    contrastText: "rgb(15, 23, 42)",
  },
  greyLight: "rgb(226, 232, 240)",
};
